import { useState } from "react";
import { DocImgBaseUrl, execess_url, execess_url_down } from "../../utils/configurable";

const useDocumentViewer = () => {
    const [isModalPreview, setIsModalPreview] = useState(false);

    const onFilterDocClick = (node) => {
        console.log("showing here")
        const imageFormats = [".png", ".jpeg", ".jpg", ".webp", "MP4"];
        const officeFormats = [".xlsx", ".xls", ".pptx", ".ppt", ".csv", ".doc", ".docx"];
        const textFormat = ".txt";

        if (imageFormats.includes(node.title)) {
            setIsModalPreview(true);
        } else if (officeFormats.includes(node?.title)) {
            const url = `https://view.officeapps.live.com/op/view.aspx?src=${execess_url}/${node.document_file_path}`;
            openWindow(url);
        } else {
            const url = `${execess_url_down}${node.document_file_path}`;
            openWindow(url);
        }
    };

    const openWindow = (url) => {
        window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=500,width=800,height=800");
    };

    return { isModalPreview, setIsModalPreview, onFilterDocClick };
};

export default useDocumentViewer;
